export default __webpack_public_path__ + "static/bg-43fe6cc612bc2f10229f8360f6aa1b05.jpg";